// Packages and components
import React, { useState } from 'react';
import { Box } from 'grommet';
import AdminTool from '../components/AdminTool';
import SHDButton from '@ui/Button/SHDButton';
import SHDContainer from '@ui/Container/SHDContainer';
import SHDHeading from '@ui/Heading/SHDHeading';
import SHDText from '@ui/Text/SHDText';
import SHDThemeOverride from '@ui/ThemeOverride/SHDThemeOverride';

// Tools
import AcceptTos from './views/AcceptTos';
import AdminUserSearch from './views/AdminUserSearch';
import DeleteUser from './views/DeleteUser';
import UpdatePhoneNumber from './views/UpdatePhoneNumber';

// Types and enums
import { FirebaseUserSearchResult } from '../admin.types';

const AdvancedUserSettings: React.FC = () => {
  const [user, setUser] = useState<FirebaseUserSearchResult | null>(null);

  return (
    <SHDThemeOverride>
      <SHDContainer maxWidth="medium">
        <AdminUserSearch onContinue={(selectedUser) => setUser(selectedUser)} />
        {user && (
          <Box
            className="advanced-user-settings__dashboard"
            margin={{ top: 'xlarge' }}
          >
            <Box
              className="advanced-user-settings__masthead"
              justify="between"
              direction="row"
              align="center"
              border={{ side: 'bottom', color: 'gray-200' }}
              pad={{ bottom: 'large' }}
            >
              <Box>
                <SHDHeading level={3} formatCasing={false}>
                  {user.name}
                </SHDHeading>

                <SHDText style="subhead-bold" color="gray-600">
                  {user.id}
                </SHDText>
              </Box>
              <Box width="5.625rem">
                <SHDButton
                  tertiary
                  label="Clear"
                  onClick={() => setUser(null)}
                />
              </Box>
            </Box>

            <Box
              className="advanced-user-settings__tools"
              margin={{ top: 'large' }}
              direction="row"
              wrap={true}
              gap="medium"
            >
              <AdminTool
                size="medium"
                className="admin-tool admin-tool__update-phone-number"
              >
                <UpdatePhoneNumber userId={user.id} />
              </AdminTool>

              <AdminTool className="admin-tool admin-tool__accept-tos">
                <AcceptTos userId={user.id} />
              </AdminTool>

              <AdminTool
                size="medium"
                className="admin-tool admin-tool__accept-tos"
              >
                <DeleteUser userId={user.id} />
              </AdminTool>
            </Box>
          </Box>
        )}
      </SHDContainer>
    </SHDThemeOverride>
  );
};

export default AdvancedUserSettings;
